<app-header class="margin-bottom-4" title="self-serve.payrollDocuments.authorizationDocuments"></app-header>

@if (!isPayrollSyncEnabled) {
    <ui-banner class="margin-bottom-4" variant="info">{{
        (isKYBEnabled()
            ? 'self-serve.payrollDocuments.ableToCompleteAfter'
            : 'self-serve.payrollDocuments.ableToSignAfter'
        ) | translate
    }}</ui-banner>
}

<div [class.loading]="isLoading" class="loadable">
    <!-- Authorization Documents steps-->
    @for (step of documentSteps | keyvalue: originalKeyValueOrder; track step.key) {
        @if (step.value; as documentStep) {
            <h3 level="2">
                {{ documentStep.title | translate }} &nbsp;
                @if (BADGE_STATUS_MAPPING[documentStep.status]; as badge) {
                    <ui-badge [type]="badge.badgeType">{{ badge.label | translate }} </ui-badge>
                }
            </h3>
            <p class="font-secondary">{{ documentStep.description | translate }}</p>
            @if (documentStep.rejectionMessage) {
                <ui-banner variant="danger">{{ documentStep.rejectionMessage }}</ui-banner>
            }
            @if (!$last && !this.isKYBEnabled()) {
                <hr class="lighter margin-y-3" />
            }
        }
    }

    @if (isPayrollSyncEnabled) {
        <div class="flex buttons justify-end margin-y-5">
            <ui-button (click)="navigateToSelfServePayrollSignDocuments()" type="primary">{{
                (isAllUploaded
                    ? 'self-serve.payrollDocuments.viewDocumentsInPayroll'
                    : 'self-serve.payrollDocuments.signDocumentsInPayroll'
                ) | translate
            }}</ui-button>
        </div>
    }

    @if (this.isKYBEnabled()) {
        <hr class="lighter margin-y-3" />
    }

    <!-- KYB step-->
    @if (this.isKYBEnabled()) {
        <h3 level="2">
            {{ 'payroll.kyc-kyb.title' | translate: { scope: 'payroll.kyc-kyb.scopes.KYB' | translate } }} &nbsp;
            @if (isPayrollSyncEnabled) {
                <app-kyc-kyb-badge [status]="KYBStatus()" />
            }
        </h3>
        <p class="font-secondary">{{ 'payroll.kyc-kyb.self-onboarding' | translate }}</p>
        <p
            class="font-secondary"
            innerHTML="{{
                'payroll.kyc-kyb.forMoreInfo.message'
                    | translate: { helpCenterUrl: 'payroll.kyc-kyb.forMoreInfo.helpCenterUrl' | translate }
            }}"
        ></p>

        @if (isPayrollSyncEnabled && isKYBIncomplete()) {
            <div class="flex buttons justify-end margin-y-5">
                <ui-button (click)="navigateToPayrollBusinessVerification()" type="primary">
                    {{ 'payroll.kyc-kyb.profile.KYB.launch' | translate }}
                </ui-button>
            </div>
        }
    }
</div>
